import Chart from 'chart.js/auto';
import ColorHash from 'color-hash';
import { BaseController } from '~/utils/base-controller';

const colorHash = new ColorHash();

/**
 * @implements {angular.IController}
 */
export default class PieChartController extends BaseController {
	/** @type {angular.IRootElementService} */
	$element;

	hasOptions = true;

	/** @type {Dashboard.PieChartWidgetOptions['options']} */
	options;

	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	constructor($injector, $element) {
		super($injector);

		this.$element = $element;
	}

	async $onChanges(changes) {
		if (changes && this.chart) {
			this.hasOptions = true;
			const newOptions = await this.getOptions();
			this.chart.data = newOptions.data;
			this.chart.update();
		}
	}

	async $onInit() {
		/** @type {HTMLCanvasElement} */
		// @ts-ignore
		const context = this.$element.find('canvas.pie-chart').get(0);

		const options = await this.getOptions();

		this.chart = new Chart(context, options);
	}

	/**
	 *
	 * @returns {Promise<import("chart.js/auto").ChartConfiguration<'pie'>>}
	 */
	async getOptions() {
		if (!this.options?.data?.column) {
			console.warn('Options are required');
			this.hasOptions = false;
		}

		const columnKid = this.options?.data?.column ?? '';

		const counts = {};
		const labels = {};

		const make = cell => {
			const element = cell;
			if (element.isa === columnKid) {
				if (!(element.kid in counts)) {
					counts[element.kid] = 0;
				}
				counts[element.kid]++;

				// ---

				labels[element.kid] = element.name;
			}
		};

		for (const row of this.data) {
			for (const cell of row) {
				if (cell.length === 1) {
					make(cell[0]);
				}
				else {
					for (const item of cell) {
						make(item);
					}
				}
			}
		}

		/** @type {import("chart.js/auto").ChartConfiguration<'pie'>} */
		const options = {
			type: 'pie',
			data: {
				labels: Object.values(labels),
				datasets: [{
					data: Object.values(counts),
					backgroundColor: Object.keys(counts).map(key => colorHash.hex(key)),
					borderWidth: 1,
				}],
			},
			options: {
				maintainAspectRatio: false,
			},
		};

		return options;
	}
}
